import React, { useEffect, useState, useRef } from 'react';
import Loader from '@hobs/components/Loader';
import './Notifications.scss';
import { DATETIME_FORMAT } from '@hobs/utils/constants';
import { formatLocal } from '@hobs/utils/formatWithTimeZone';
import Icon from '../Icon';
import { useOuterClick } from '@hobs/utils/useOuterClick';
import EmailNotificationSettingsModal from '../../containers/Notifications/EmailNotificationSettingsModal';

export const Notifications = ({
  onLoadMore,
  notificationCount,
  data = [],
  loading,
  onSelected
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailNotificationSettingsModalOpen, setIsEmailNotificationSettingsModalOpen] = useState(false);
  const loadMoreOptionRef = useRef();
  const outerClickRef = useOuterClick(() => {
    setIsOpen(false);
  });

  useEffect(() => {
    // load notifications when Load More becomes visible
    if (!isOpen || !notificationCount) return;

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        loadMoreOptionRef.current.click();
      }
    });

    if (!loadMoreOptionRef.current) return;

    observer.observe(loadMoreOptionRef.current);
  }, [isOpen]);

  useEffect(() => {
    setIsLoading(false);
  }, [data]);

  const onToggle = () => {
    setIsOpen(!isOpen);
  };

  const onOptionSelected = notification => {
    onSelected(notification);
    setIsOpen(false);
  };

  const load = () => {
    if (isLoading) {
      return;
    }

    onLoadMore({ skip: data.length });
    setIsLoading(true);
  };

  const renderLoadMoreOption = () => {
    if (notificationCount <= data.length) return <></>;

    return (
      <>
        <hr className="line-break"></hr>
        <div
          className="load-more-option"
          onClick={load}
          ref={loadMoreOptionRef}
        >
          {!isLoading && data.length > 0 ? 'Load more' : 'Loading...'}
        </div>
      </>
    );
  };

  const renderOptions = () => (
    <div className="options">
      <div className="header">
        {notificationCount == 0 ? (
          <span>No actions requred</span>
        ) : (
          <span>Urgent action required ({notificationCount})</span>
        )}
        <div 
          onClick={() => setIsEmailNotificationSettingsModalOpen(true)} 
          className='header--notification-settings'
        >
          <Icon icon="settings" />
          <span>Manage email notifications</span>
        </div>
      </div>
      {!!data.length && <hr className="line-break"></hr>}
      {loading && (
        <div className="loader">
          <Loader />
        </div>
      )}
      {!loading &&
        data.map((item, i, row) => (
          <div
            key={i}
            className="search-option"
            onClick={() => onOptionSelected(item)}
          >
            <div className="option-content">
              <div className="indicator-wrapper">
                <div className="indicator" />
              </div>
              <div>
                <p className="title">{`Request ${item.RequestNumber}`}</p>
                <p className="message">{item.IndicationDescription}</p>
                <p className="date">
                  {formatLocal(item.LastChangeDate, DATETIME_FORMAT)}
                </p>
              </div>
            </div>
            {i + 1 !== row.length && <hr className="line-break"></hr>}
          </div>
        ))}
      {renderLoadMoreOption()}
    </div>
  );

  return (
    <>
      <EmailNotificationSettingsModal
        isOpen={isEmailNotificationSettingsModalOpen}
        onClose={() => {
          setIsEmailNotificationSettingsModalOpen(false);
          setIsOpen(false);
        }}
      />
      <div ref={outerClickRef} className="notification">
        <span style={{ cursor: 'pointer' }}>
          <Icon icon="bell" onClick={onToggle} />
        </span>
        {notificationCount !== 0 && (
          <span className="badge">
            <p>{notificationCount}</p>
          </span>
        )}
        {isOpen && renderOptions()}
      </div>
    </>
  );
};
